"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.defaultAdTrack = void 0;

var _react = _interopRequireDefault(require("react"));

var _emptyFunction = _interopRequireDefault(require("fbjs/lib/emptyFunction"));

// import
// definition
var defaultAdTrack = {
  custom: _emptyFunction["default"],
  addToCart: _emptyFunction["default"],
  viewProduct: _emptyFunction["default"],
  search: _emptyFunction["default"],
  addToWishList: _emptyFunction["default"],
  completeRegistration: _emptyFunction["default"],
  beginCheckout: _emptyFunction["default"],
  purchase: _emptyFunction["default"]
};
exports.defaultAdTrack = defaultAdTrack;

var _default = /*#__PURE__*/_react["default"].createContext(defaultAdTrack);

exports["default"] = _default;